<template>
  <div class="pwc-coupon-info">
    <van-nav-bar title="我的优惠券" left-arrow fixed @click-left="handleReturn" />
    <div class="container">
      <van-image
        v-for="(item, index) in coupons"
        :key="index"
        width="100%"
        lazy-load
        style="margin-bottom: 10px; padding: 5px 10px"
        :src="item.couponImageUrl"
      />
      <div v-if="coupons.length < 1" style="text-align: center;font-size: 18px;">暂无数据</div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { NavBar, Image, Lazyload } from 'vant'
import RouterName from '@/constants/route'
import { mapState, mapActions } from 'vuex'
// import Actions from '@/constants/action'
import { http } from '@/api'
import { Account } from '@/api/collection'

Vue.use(Lazyload)
export default {
  components: {
    VanNavBar: NavBar,
    VanImage: Image
  },
  data() {
    return {
      coupons: []
    }
  },
  computed: {
    ...mapState(['userInfo'])
  },
  created() {
    // this.getBaseInfo()
    this.getCoupons()
  },
  methods: {
    ...mapActions({
      // getBaseInfo: Actions.GET_BASE_INFO
    }),
    handleReturn() {
      this.$router.replace({
        name: RouterName.home,
        query: {
          active: 'self'
        }
      })
    },
    async getCoupons() {
      const res = await http(
        {
          path: Account.GetLeadCouponList.path,
          method: Account.GetLeadCouponList.method
        }
      )
      if (res.resultCode === '0') {
        this.coupons = res.coupons
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .pwc-coupon-info {
    .container {
      margin-top: 35px;
    }
  }
</style>
